module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Most of the essays in this volume were earlier presented in the form of public lectures in a series entitled “Scripture, Theology and Culture: Acts of Interpretation,” organized collaboratively by the Canada Research Chair in Interpretation, Religion, and Culture (held by Jens Zimmermann) and the Religious Studies department (represented by Tony Cummins) at Trinity Western University, Langley, British Columbia. The lectures took place during the period from September 2013 to November 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We gratefully acknowledge the Canada Research Council, whose funding for the Canada Research Chair program supported this lecture series and publication. The lectures by Dr. Peter Enns and Dr. Craig Bartholomew were also co-sponsored by the Canadian Scientific & Christian Affiliation and the Vancouver Area Science & Religion Forum.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The editors would like to thank Natalie Boldt for her administrative assistance with the public lecture series, and Kyle Parsons for his editorial work. We are also indebted to our colleague Dr. Craig Broyles for his linguistic and technical expertise. In addition, we are grateful for James Ernest’s willingness to recommend this volume to the Eerdmans publishing committee, and we thank Mary Hietbrink, Justin Howell, and the editorial team at Eerdmans for their kind assistance in finalizing the manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, we express our gratitude to each of the contributors for their warm collegiality, their patience throughout the publication process, and their fine essays. They are to be commended for their long-standing and collective commitment to the integration of Scripture and theology, and to its vital role in the church and the world.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c8b14fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgements.vue
// module id = 66
// module chunks = 0